<template>
  <div class="d-inline">
    <slot v-if="enabled" />
    <v-btn v-else color="default" @click="$emit('update:enabled', true)">
      <v-icon>add</v-icon>  &nbsp; {{ name | startCase }}
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'OptionalField',
  props: {
    enabled: Boolean,
    name: String
  }
}
</script>
